import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Layout from "../components/Layout";
import Home from "../pages/Home";
import Anime from "../pages/Anime";
import WatchAnime from "../pages/WatchAnime.jsx";
import { AppContext } from "../context/AppContext";
import useInitialState from "../hooks/useInitialState";
import "../styles/App.css";

function App() {
  const initialState = useInitialState();

  return (
    <div className="App">
      <AppContext initialState={initialState}>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route path="/:id" element={<Anime />} />
              <Route path="/:id/:episode" element={<WatchAnime />} />
              <Route
                path="*"
                element={<div className="text-white">not found</div>}
              />
            </Routes>
            <Outlet />
          </Layout>
        </BrowserRouter>
      </AppContext>
    </div>
  );
}

export default App;
